import { Users } from "lucide-react";
import { ROOMS } from "@/constants/site";

export const Rooms = ({ onBookRoom }) => {
  return (
    <section id="stays" data-testid="rooms-section" className="py-24 md:py-32 bg-[#F3F0EA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#C5A880]">Stays</p>
          <h2 className="font-serif-display font-light text-3xl md:text-4xl lg:text-5xl tracking-tight text-[#0B3B39] mt-4 leading-tight">
            Rooms shaped by the forest.
          </h2>
          <p className="text-base leading-relaxed text-[#4A5568] mt-6">
            Simple nightly rates, no hidden costs — your final price is confirmed when we accept your reservation request.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          {ROOMS.map((room) => (
            <article
              key={room.id}
              data-testid={`room-card-${room.id}`}
              className="bg-white border border-[#E6E2D8] shadow-[0_8px_30px_rgb(0,0,0,0.04)] group overflow-hidden"
            >
              <div className="overflow-hidden h-72">
                <img
                  src={room.image}
                  alt={room.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="p-8">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif-display text-2xl text-[#0B3B39]">{room.name}</h3>
                  <span className="flex items-center gap-1.5 text-xs text-[#4A5568] whitespace-nowrap mt-1.5">
                    <Users size={14} /> {room.guests} · {room.inventory} {room.inventory === 1 ? "room" : "rooms"}
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-[#4A5568] mt-3">{room.description}</p>
                <div className="flex items-center justify-between mt-6 pt-6 border-t border-[#E6E2D8]">
                  <span data-testid={`room-price-${room.id}`} className="text-sm font-semibold text-[#0B3B39]">
                    {room.price}
                  </span>
                  <button
                    data-testid={`room-book-btn-${room.id}`}
                    onClick={() => onBookRoom(room.name)}
                    className="bg-[#0B3B39] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] font-semibold px-6 py-3 rounded-sm hover:bg-[#072A28] transition-colors duration-300"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
